import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import "../styles/navbar.css";
import Home from "../pages/Home";
import Market from "../pages/Services";
import Contact from "../pages/Contact";
import Logo from "../assets/images/logo_INT.png";

export default function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to handle screen resize
    const handleResize = () => {
      setScreenWidth(window.innerWidth);

      // Automatically close the menu if the screen is larger than 768px
      if (window.innerWidth > 768) {
        setToggleMenu(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Call the handler once to set initial state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array ensures it runs only on mount/unmount

  const handleLinkClick = () => {
    setToggleMenu(false); // Close the menu on link click
  };

  return (
    <div>
      <div className="navbar">
        <div className="navbar-logo">
          <NavLink to="/">
            <img src={Logo} />
          </NavLink>
        </div>
        <div className="navbar-links">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/aboutus">About Us</NavLink>
          <NavLink to="/contact">Contact Us</NavLink>
        </div>
        <div className="navbar-contact-link">
          <NavLink to="/contact">Get in Touch</NavLink>
        </div>
        <div className="navbar-menu">
          {toggleMenu ? (
            <RiCloseLine
              className="menu-icon"
              onClick={() => setToggleMenu(false)}
            />
          ) : (
            <RiMenu3Line
              className="menu-icon"
              onClick={() => setToggleMenu(true)}
            />
          )}
        </div>
      </div>
      {toggleMenu && (
        <div className="navbar-menu-container">
          <div className="navbar-menu-container-links">
            <NavLink to="/" onClick={handleLinkClick}>
              Home
            </NavLink>
            <NavLink to="/services" onClick={handleLinkClick}>
              Services
            </NavLink>
            <NavLink to="/aboutus" onClick={handleLinkClick}>
              About Us
            </NavLink>
            <NavLink to="/contact" onClick={handleLinkClick}>
              Contact
            </NavLink>
          </div>
        </div>
      )}
    </div>
  );
}
